module.exports = __webpack_public_path__ + "static/img/kot.884ad81e.jpg";